import { useBrokerContext } from '@/app/context';
import { BrokerInactiveNotice } from '@/features/brokers/components/broker-inactive-notice.component';
import { useSelectedBrokerWriteGuard } from '@/features/brokers/hooks';
import { requirePermissions } from '@/shared/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { Home } from 'lucide-react';
import { ProposalsContent } from '../../../features/proposals/components';
import { Page, PageHeader } from '../../../shared/ui/page';

export const Route = createFileRoute('/_app/proposals/')({
  component: RouteComponent,
  beforeLoad: async () => {
    const hasPermission = await requirePermissions(['policies.proposals.read']);
    if (!hasPermission) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function RouteComponent() {
  const { selectedBroker } = useBrokerContext();
  const proposalWriteGuard = useSelectedBrokerWriteGuard('proposal');

  return (
    <Page.Root>
      <Page.Breadcrumb
        items={[
          {
            label: 'Página Inicial',
            href: '/dashboard',
            iconLeft: <Home className='h-4 w-4' />,
          },
          { label: 'Comercial' },
          { label: 'Propostas', active: true },
        ]}
      />

      <PageHeader.Root>
        <PageHeader.Main>
          <PageHeader.TitleGroup>
            <PageHeader.Title>Propostas</PageHeader.Title>
            <PageHeader.Subtitle>
              Gerencie e acompanhe todas as cotações de seguros
            </PageHeader.Subtitle>
          </PageHeader.TitleGroup>
        </PageHeader.Main>
      </PageHeader.Root>

      <BrokerInactiveNotice guards={[proposalWriteGuard]} />

      <ProposalsContent selectedBroker={selectedBroker} />
    </Page.Root>
  );
}
